export const ACCOUNT_MAIN_INDEX = 0
export const ACCOUNT_MAX_SUB_INDEX = 256
export const ACCOUNT_PAD_SIZE = 20
